export const authUrl = "/api/v1/admin";
export const orderUrl = "/api/v1/orders";
export const userUrl = "/api/v1/users";
export const paymentUrl = "/api/v1/payments";
export const couponUrl = "/api/v1/coupons";
export const indexCheckUrl = "/api/v1/index-check";
